import * as yup from 'yup';

export const costManufacturerSchema = yup.object({
  costStartDate: yup.string().nullable(),
  costEndDate: yup.string().nullable(),
  manufacturerType: yup.string().nullable(),
  manufacturer: yup.object().nullable(),
});
